import { render, staticRenderFns } from "./SysConfig.vue?vue&type=template&id=a0a5ac20&scoped=true&lang=pug&"
import script from "./SysConfig.vue?vue&type=script&lang=ts&"
export * from "./SysConfig.vue?vue&type=script&lang=ts&"
import style0 from "./SysConfig.vue?vue&type=style&index=0&id=a0a5ac20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a5ac20",
  null
  
)

export default component.exports